import Vue from 'vue'
const $ = window.$
export default Vue.directive('tooltip', {
  inserted: function (el, binding, vnode) {
    $(el).tooltip()
  }
})
